/* src/app/ships/ship-register-merchants/ship-register-merchants.component.css */
.actionSucess {
  background: #4E9414;
  width: 200px;
  height: 100px;
  padding: 6px;
  font-family: Open Sans;
  font-weight: normal;
  font-size: 8pt;
  color: #ffffff;
}
.searchResultName {
  cursor: pointer;
}
/*# sourceMappingURL=ship-register-merchants.component.css.map */
